/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import classes from "./orders.module.css";
import OrderTable from "./orderTable";
import Input from "../../../component/inputpm";
import Loader from "../../../component/loader";
import ResendDialog from "../order/resendDialog";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Select from "@mui/material/Select";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import Breadcrumb from "../../../component/breadcrumb";
import Tooltip from "@mui/material/Tooltip";
import Paper from "@mui/material/Paper";
import { IconButton } from "@mui/material";
import {
  SearchIcon,
  ClearIcon,
  RefreshIcon,
  DetailView,
  ListView,
  UsersIcon,
} from "../../../component/icons/icons";
import Button from "../../../component/button";
import { Grid } from "@mui/material";
import UriEncode from "../../../component/uriEncode/uriEncode";
import Card from "@mui/material/Card";
import ManageCustomersHierarchy from "../manageCustomers/manageCustomersHierarchy";
import { ButtonGroup } from "@mui/material";
import { withNavigation } from "../../../helper/withNavigation";
import dateFormat from "dateformat";

// Manage order page class
class Orders extends Component {
  // Declare property values that belongs to the component
  state = {
    orders: [],
    orderId: "",
    customerName: "",
    customerBAN: "",
    orderStatus: "",
    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    totalOrderCount: 0,
    loading: true,
    actionOrderId: "",
    isMailDialog: false,
    sortBy: "orderDate",
    sortOrder: "DESC",
    controls: true,
    tenant: "",

    // Order status list
    statusList: [],

    tenantList: [],
    bread: [
      {
        title:
          this.props.providerType === "SALES_CHNL_PROVIDER"
            ? this.props.t("ORDERS")
            : this.props.t("FULFILMENT_REQUEST"),
        url: "/orders",
      },
    ],
    showLoading: true,
    isMobile: false,
    showCustomerList: false,
    showAllOrders: undefined,
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    this.updateIsMobile();
    // const initialShowAllOrders = this.props.providerType === "SALES_CHNL_PROVIDER"
    //     ? localStorage.getItem('orderView') === 'list'
    //     : false;
    // if (this.props.providerType === "SALES_CHNL_PROVIDER") {
    //     const orderView = localStorage.getItem('orderView');
    //     this.setState({
    //         showAllOrders: orderView === 'list' ? true : false
    //     });
    // } else {
    //     const orderView = localStorage.getItem('orderView');
    //     this.setState({
    //         showAllOrders: orderView === 'list' ? true : false
    //     });
    // }
    const orderView = localStorage.getItem("orderView");
    if (orderView === null) {
      this.setState({
        showAllOrders: this.props.providerType !== "SALES_CHNL_PROVIDER",
      });
    } else {
      this.setState({
        showAllOrders: orderView === "list",
      });
    }
    // this.setState({
    //     showAllOrders: orderView === 'list' ? true : false
    // });
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_ORDER_STATUSES/endpoint`,
      {},
    )
      .then((res) => {
        let list = res.data;
        // let all = {
        //     name: 'All Orders',
        //     value: 'All Orders'
        // }
        // list.unshift(all)
        this.setState({
          statusList: res.data,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          console.log("err", err);
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      BusApiCall(
        "POST",
        `${constants.busInternalUrl}/passthru/GET_CHILD_TENANT_LIST/endpoint`,
        {},
      )
        .then((res) => {
          const list = res.data.tenants;
          const initialFilters = JSON.parse(
            localStorage.getItem("orderFilters"),
          );
          const initialTenant =
            initialFilters && initialFilters.tenant
              ? initialFilters.tenant
              : list && list.length > 0
                ? list[0].tenantId
                : "";

          this.setState(
            {
              tenantList: list,
              tenant: initialTenant,
              // showAllOrders: initialShowAllOrders
            },
            () => {
              if (this.state.showAllOrders) {
                this.callGetOrders();
              }
              // if (list && list.length > 0) {
              //     let initialFilters = JSON.parse(localStorage.getItem('orderFilters'));
              //     this.setState({
              //         tenant: (initialFilters && initialFilters.tenant) ? initialFilters.tenant : list[0].tenantId
              //     }, () => {
              //         if (this.state.showAllOrders) {
              //             this.callGetOrders();
              //         }
              //     });
              // } else {
              //     if (this.state.showAllOrders) {
              //         this.callGetOrders();
              //     }
              // }
            },
          );
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            console.log("err", err);
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        });
    } else {
      if (this.state.showAllOrders) {
        this.callGetOrders();
      }
    }
  }
  componentDidUpdate(prevProps, prevState) {
    // If showAllOrders changed from false to true
    if (!prevState.showAllOrders && this.state.showAllOrders) {
      this.callGetOrders();
    }
  }
  updateIsMobile = () => {
    const isMobile = window.matchMedia("(max-width: 960px)").matches;
    this.setState({ isMobile });
  };

  callGetOrders = () => {
    if (
      this.props.providerType === "SOLUTION_PROVIDER" &&
      (!this.state.tenantList || !this.state.tenant)
    ) {
      console.log("Waiting for tenants to load...");
      return;
    }
    let initialFilters = JSON.parse(localStorage.getItem("orderFilters"));
    if (initialFilters) {
      this.setState(
        {
          rowsPerPage: initialFilters.rowsPerPage,
          startRecord: initialFilters.startRecord,
          page: initialFilters.page,
          sortBy: initialFilters.sortBy,
          sortOrder: initialFilters.sortOrder,
          orderId: initialFilters.orderId,
          orderStatus: initialFilters.orderStatus,
          customerBAN: initialFilters.customerBAN,
          customerName: initialFilters.customerName,
          tenant: initialFilters.tenant
            ? initialFilters.tenant
            : this.state.tenantList && this.state.tenantList.length > 0
              ? this.state.tenantList[0].tenantId
              : "",
        },
        () => {
          this.getOrders();
        },
      );
    } else {
      this.getOrders();
    }
  };
  toggleShowCustomerList = () => {
    this.setState((prevState) => ({
      showCustomerList: !prevState.showCustomerList,
    }));
  };
  getTenantId = () => {
    if (this.state.tenant) {
      return this.state.tenant;
    }

    if (this.state.tenantList?.length > 0) {
      return this.state.tenantList[0].tenantId;
    }

    return "";
  };
  // Fetch orders list
  getOrders = () => {
    this.setState({
      loading: true,
      showLoading: true,
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };

    // START: Store order filters data
    let orderFilters = {
      rowsPerPage: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
      page: this.state.page,
      sortBy: this.state.sortBy,
      sortOrder: this.state.sortOrder,

      orderId: this.state.orderId,
      orderStatus:
        this.state.orderStatus === "All Orders" ? "" : this.state.orderStatus,
      customerBAN: this.state.customerBAN,
      customerName: this.state.customerName,
      tenant: this.state.tenant,
    };
    localStorage.setItem("orderFilters", JSON.stringify(orderFilters));
    // END: Store order filters data

    const tenantData =
      this.props.providerType === "SOLUTION_PROVIDER"
        ? { tenantId: this.getTenantId() }
        : {};

    BusApiCall(
      "GET",
      `${constants.busV4Url}/orders?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&orderId=${this.state.orderId}&orderStatus=${UriEncode(this.state.orderStatus)}&customerName=${this.state.customerName ? this.state.customerName : ""}&customerBan=${this.state.customerBAN ? this.state.customerBAN : ""}`,
      tenantData,
      pageOptions,
    )
      .then((res) => {
        let data = res.data;
        if (data.length > 0) {
          for (let item of data) {
            item.accountName = item.customer.companyName;
            item.ban = item.customer.ban;
            // Check whether the order is auto-activated or not
            for (let userItem of item.userData) {
              if (userItem.name === "autoActivatable") {
                item.autoActivatable = userItem.value;
              }
            }
          }
          this.setState({
            orders: data,
            totalOrderCount: +res.headers["x-total-count"],
            loading: false,
            showLoading: false,
          });
        } else {
          this.setState({
            orders: [],
            totalOrderCount: 0,
            loading: false,
            showLoading: false,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          console.log("err", err);
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  // Update state data on input change
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Open resend confirmation email modal
  openResendDialog = (orderId) => {
    this.setState({
      isMailDialog: true,
      actionOrderId: orderId,
    });
  };

  // Change page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Close confirmation email dialog
  closeMailDialog = () => {
    this.setState({
      isMailDialog: false,
      actionOrderId: "",
    });
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getOrders();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getOrders();
        },
      );
    }
  };

  // Search/Filter orders
  filterOrderTable = () => {
    this.setState(
      {
        page: 1,
        startRecord: 1,
        orderId: this.state.orderId,
        customerName: this.state.customerName,
        customerBAN: this.state.customerBAN,
        orderStatus: this.state.orderStatus,
        tenant: this.state.tenant,
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Clear all search filters
  clearOrderTableSearch = () => {
    this.setState(
      {
        orderId: "",
        customerName: "",
        customerBAN: "",
        orderStatus: "",
        tenant: "",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Clear all search filters and refeesh data
  refreshOrderTableSearch = () => {
    this.setState(
      {
        orderId: "",
        customerName: "",
        customerBAN: "",
        orderStatus: "",
        tenant: "",
        page: 1,
        startRecord: 1,
        sortBy: "orderDate",
        sortOrder: "DESC",
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Search orders on press enter key
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterOrderTable();
    }
  };

  toggleShowAllOrders = (view) => {
    localStorage.setItem("orderView", view);
    if (view === "list") {
      this.setState(
        {
          showAllOrders: true,
        },
        () => {
          this.callGetOrders();
        },
      );
    } else if (view === "detail") {
      this.setState({
        showAllOrders: false,
      });
    } else {
      this.setState((prevState) => ({
        showAllOrders: !prevState.showAllOrders,
      }));
    }
  };
  // Render order view
  render() {
    const { t } = this.props;
    const { isMobile, showCustomerList } = this.state;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container spacing={1}>
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
              <Grid
                item
                style={{ textAlign: "right" }}
                size={{
                  xs: 6,
                }}
              >
                {/* {
                  this.props.menuPaths.includes("/newOrder") &&
                    this.props.userPerms.includes("ORDERMGR_SALES_CREATE") && (
                      <Button
                        onClick={() => this.props.router.navigate("/newOrder")}
                      >
                        <span
                          style={{
                            marginRight: ".25rem",
                            verticalAlign: "middle",
                          }}
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        {this.props.t("NEW_ORDER")}
                      </Button>
                    )
                } */}
              </Grid>
            </Grid>
          </div>
        </div>
        <main style={{ position: "relative", paddingTop: "1rem" }}>
          {
            // this.props.providerType === "SALES_CHNL_PROVIDER" &&
            <Grid container spacing={1}>
              {/* <Grid item xs={12} md={6} justifyContent="flex-end">
                                <FormControlLabel
											control={
												<Switch
													color="primary"
													checked={this.state.showAllOrders}
													name="showAllOrders"
													onChange={(e) => this.toggleShowAllOrders()}
												/>
											}
											label={this.props.t("SHOW_ALL_ORDERS")}
										/>
                            </Grid> */}
              <Grid
                item
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "flex-end",
                  marginBottom: "1rem",
                }}
                size={{
                  xs: 12,
                  md: 12,
                }}
              >
                {isMobile && (
                  <Button
                    className="buttonSecondary"
                    onClick={this.toggleShowCustomerList}
                  >
                    <span
                      style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                    >
                      <UsersIcon />
                    </span>
                    {t("SHOW_CUSTOMER_LIST")}
                  </Button>
                )}
                <ButtonGroup variant="outlined">
                  {/* DETAIL VIEW button */}
                  <span
                    className={`buttonGroup ${!this.state.showAllOrders ? "selected" : ""}`}
                    onClick={(e) => this.toggleShowAllOrders("detail")}
                    style={{
                      backgroundColor: !this.state.showAllOrders
                        ? this.props.tenantData.color
                        : "inherit",
                      color: !this.state.showAllOrders ? "white" : "inherit",
                    }}
                  >
                    <span style={{ marginRight: ".4rem" }}>
                      {this.props.t("DETAIL_VIEW")}
                    </span>
                    <DetailView />
                  </span>
                  {/* LIST VIEW button */}
                  <span
                    className={`buttonGroup ${this.state.showAllOrders ? "selected" : ""}`}
                    onClick={(e) => this.toggleShowAllOrders("list")}
                    style={{
                      backgroundColor: this.state.showAllOrders
                        ? this.props.tenantData.color
                        : "inherit",
                      color: this.state.showAllOrders ? "white" : "inherit",
                    }}
                  >
                    <span>{this.props.t("LIST_VIEW")}</span>
                    <ListView />
                  </span>
                </ButtonGroup>
              </Grid>
            </Grid>
          }
          {!this.state.showAllOrders ? (
            <>
              <ManageCustomersHierarchy
                screen="orders"
                userId={this.state.userId}
                onRef={(ref) => (this.hierarchyRef = ref)}
                isMobile={isMobile}
                showCustomerList={showCustomerList}
                toggleShowCustomerList={this.toggleShowCustomerList}
                openResendDialog={this.openResendDialog}
                controls={this.state.controls}
                loggedInUserType={this.props.loggedInUserType}
                providerType={this.props.providerType}
                showLoading={this.state.showLoading}
                // orderStatus={this.state.orderStatus}
                statusList={this.state.statusList}
                // onChange={this.onChange}
                // onSearchKeyDown={this.onSearchKeyDown}
                // tenant={this.state.tenant}
                // tenantList={this.state.tenantList}
                // filterOrderTable={this.filterOrderTable}
                // clearOrderTableSearch={this.clearOrderTableSearch}
                // refreshOrderTableSearch={this.refreshOrderTableSearch}
                parentTenantId={this.state.tenant}
                setErrorMessage={this.props.setErrorMessage}
              />
              <ResendDialog
                isOpen={this.state.isMailDialog}
                close={this.closeMailDialog}
                orderId={this.state.actionOrderId}
              />
            </>
          ) : (
            <>
              {/* <Paper className="tablePaper"> */}
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ marginBottom: ".5rem" }}>
                  {/* Search filters start */}
                  <div className={classes.searchOuterDiv}>
                    {this.props.providerType === "SOLUTION_PROVIDER" && (
                      <div className={classes.searchInputDiv}>
                        <Select
                          native
                          size={"small"}
                          variant={"outlined"}
                          name={"tenant"}
                          inputProps={{
                            name: "tenant",
                            id: "outlined-native-tenant",
                          }}
                          //value={(a) => a.value}
                          value={this.state.tenant}
                          onChange={(e) => {
                            this.onChange(e);
                          }}
                          onKeyDown={(e) => {
                            this.onSearchKeyDown(e);
                          }}
                          selectClass={
                            classes.inputClass +
                            " " +
                            classes.statusSelectBg +
                            " " +
                            classes.searchOrderSelect
                          }
                        >
                          {this.state.tenantList.map((a) => (
                            <option key={a.tenantId} value={a.tenantId}>
                              {a.tenantName}
                            </option>
                          ))}
                        </Select>
                      </div>
                    )}
                    <div className={classes.searchInputDiv}>
                      <Input
                        size={"small"}
                        variant={"outlined"}
                        placeholder={t("ORDER_ID")}
                        value={this.state.orderId}
                        name={"orderId"}
                        onChange={(e) => {
                          this.onChange(e);
                        }}
                        divClass={classes.inputClass}
                        onKeyDown={(e) => {
                          this.onSearchKeyDown(e);
                        }}
                      />
                    </div>
                    {(this.props.loggedInUserType != "ECOMMERCE_CUSTOMER" ||
                      this.props.loggedInUserType != "ECOMMERCE_ADMIN") && (
                      <>
                        <div className={classes.searchInputDiv}>
                          <Input
                            size={"small"}
                            variant={"outlined"}
                            placeholder={t("CUSTOMER_NAME")}
                            value={this.state.customerName}
                            name={"customerName"}
                            onChange={(e) => {
                              this.onChange(e);
                            }}
                            divClass={classes.inputClass}
                            onKeyDown={(e) => {
                              this.onSearchKeyDown(e);
                            }}
                          />
                        </div>
                        {this.props.providerType === "SALES_CHNL_PROVIDER" && (
                          <div className={classes.searchInputDiv}>
                            <Input
                              size={"small"}
                              variant={"outlined"}
                              placeholder={t("CUSTOMER_BAN")}
                              value={this.state.customerBAN}
                              name={"customerBAN"}
                              onChange={(e) => {
                                this.onChange(e);
                              }}
                              divClass={classes.inputClass}
                              onKeyDown={(e) => {
                                this.onSearchKeyDown(e);
                              }}
                            />
                          </div>
                        )}
                      </>
                    )}
                    <div
                      className={classes.searchInputDiv}
                      style={{ maxWidth: "250px" }}
                    >
                      {/* <Select
                            selectClass={classes.inputClass, classes.statusSelectBg, classes.selectHeight}
                            name={'orderStatus'}
                            selected={this.state.orderStatus}
                            options={this.state.statusList}
                            optionLabel={(a) => a.name}
                            value={(a) => a.value}
                            onChange={(e) => { this.onChange(e) }}
                            onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                        /> */}
                      <Select
                        native
                        // size={'small'}
                        style={{ width: "245px" }}
                        variant={"outlined"}
                        name={"orderStatus"}
                        inputProps={{
                          name: "orderStatus",
                          id: "outlined-native-orderStatus",
                        }}
                        //value={(a) => a.value}
                        value={this.state.orderStatus}
                        onChange={(e) => {
                          this.onChange(e);
                        }}
                        onKeyDown={(e) => {
                          this.onSearchKeyDown(e);
                        }}
                        selectClass={
                          classes.inputClass +
                          " " +
                          classes.statusSelectBg +
                          " " +
                          classes.searchOrderSelect
                        }
                      >
                        <option value={"All Orders"}>All Orders</option>
                        {this.state.statusList
                          .sort((a, b) => a.value.localeCompare(b.value))
                          .map((a) => (
                            <option key={a.value} value={a.value}>
                              {a.value}
                            </option>
                          ))}
                      </Select>
                    </div>
                    {/* <div className={classes.searchOrderLabelOuter}>
                                <div className={classes.searchOrderLabelInner}> */}
                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                      <Tooltip title={t("SEARCH")}>
                        <IconButton
                          className="iconButtonSecondary"
                          onClick={this.filterOrderTable}
                        >
                          <SearchIcon />
                        </IconButton>
                      </Tooltip>{" "}
                      &nbsp;
                      <Tooltip title={t("CLEAR")}>
                        <IconButton
                          className="iconButtonSecondary"
                          onClick={this.clearOrderTableSearch}
                        >
                          <ClearIcon />
                        </IconButton>
                      </Tooltip>{" "}
                      &nbsp;
                      <Tooltip title={t("REFRESH")}>
                        <IconButton
                          className="iconButtonSecondary"
                          onClick={this.refreshOrderTableSearch}
                        >
                          <RefreshIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                    {/* </div>
                            </div> */}
                    {/* <div className='cl'></div> */}
                  </div>
                </div>
                {/* Search filters end */}
                <Card
                  variant="outlined"
                  style={{ borderRadius: "8px", marginBottom: "40px" }}
                >
                  {/* Order table component */}
                  <OrderTable
                    orderId={this.state.orderId}
                    customerName={this.state.customerName}
                    customerBAN={this.state.customerBAN}
                    orders={this.state.orders}
                    openResendDialog={this.openResendDialog}
                    rowsPerPage={this.state.rowsPerPage}
                    totalOrderCount={this.state.totalOrderCount}
                    page={this.state.page}
                    sortBy={this.state.sortBy}
                    sortOrder={this.state.sortOrder}
                    updateSorting={this.updateSorting}
                    handleChangePage={this.handleChangePage}
                    handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                    controls={this.state.controls}
                    loggedInUserType={this.props.loggedInUserType}
                    tenantId={this.state.tenant}
                    providerType={this.props.providerType}
                    showLoading={this.state.showLoading}
                  />
                </Card>
                {/* </Paper> */}
              </div>

              {/* Resend confirmation dialog component */}
              <ResendDialog
                isOpen={this.state.isMailDialog}
                close={this.closeMailDialog}
                orderId={this.state.actionOrderId}
              />
              <Loader loading={this.state.loading} />
            </>
          )}
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
    loggedInUserType: state.auth.userLoginType,
    providerType: state.auth.providerType,
    menuPaths: state.auth.menuPaths,
    userPerms: state.auth.userPerms,
    tenantData: state.auth.tenantData,
    showMyCustomers: state.auth.showMyCustomers,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(Orders)));
